import { render } from "./ScanTabletOperator.vue?vue&type=template&id=9b764b04"
import script from "./ScanTabletOperator.vue?vue&type=script&lang=ts"
export * from "./ScanTabletOperator.vue?vue&type=script&lang=ts"

import "./ScanTabletOperator.vue?vue&type=style&index=0&id=9b764b04&lang=scss"
script.render = render

export default script